export default __webpack_public_path__ + "static/media/naga-egg.dd511b96.gif";